import { useQuery } from "@tanstack/react-query";
import commonLookupService from "../services/commonLookupService";
import { recordError } from "../utils/logService";

const faqModuleKeys = {
    all: ["faq-modules"],
};

export function useFaqModules() {
    return useQuery({
        queryKey: faqModuleKeys.all,
        queryFn: async () => {
            try {
                const response = await commonLookupService.getFaqModule();
                return response?.data || [];
            } catch (error) {
                recordError(error);
                throw error;
            }
        },
        staleTime: 30_000,
        keepPreviousData: true
    });
}